// import the library
import { Gyro } from "../src/libs/Gyro/Gyro.js";

// hoist to concat namespace
window.concat = window.concat || {};
window.concat.Gyro = Gyro;
